import { render, staticRenderFns } from "./card1.vue?vue&type=template&id=2fdb814a&scoped=true&"
import script from "./card1.vue?vue&type=script&lang=js&"
export * from "./card1.vue?vue&type=script&lang=js&"
import style0 from "./card1.vue?vue&type=style&index=0&id=2fdb814a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb814a",
  null
  
)

export default component.exports